/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `CREATED` - Created
 * * `IN_PROGRESS` - In Progress
 * * `WAITING_AV_CHECK` - Waiting Av Check
 * * `READY` - Ready
 * * `VIRUS_DETECTED` - Virus Detected
 * @export
 */
export const FileStatusEnum = {
    Created: 'CREATED',
    InProgress: 'IN_PROGRESS',
    WaitingAvCheck: 'WAITING_AV_CHECK',
    Ready: 'READY',
    VirusDetected: 'VIRUS_DETECTED'
} as const;
export type FileStatusEnum = typeof FileStatusEnum[keyof typeof FileStatusEnum];


export function instanceOfFileStatusEnum(value: any): boolean {
    for (const key in FileStatusEnum) {
        if (Object.prototype.hasOwnProperty.call(FileStatusEnum, key)) {
            if (FileStatusEnum[key as keyof typeof FileStatusEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FileStatusEnumFromJSON(json: any): FileStatusEnum {
    return FileStatusEnumFromJSONTyped(json, false);
}

export function FileStatusEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): FileStatusEnum {
    return json as FileStatusEnum;
}

export function FileStatusEnumToJSON(value?: FileStatusEnum | null): any {
    return value as any;
}

export function FileStatusEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): FileStatusEnum {
    return value as FileStatusEnum;
}

